// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { application } from "./application"

// Import each controller individually (esbuild doesn't support require.context)
import AutocompleteController from "./autocomplete_controller"
import BraintreeController from "./braintree_controller"
import CarrierautocompleteController from "./carrierautocomplete_controller"
import CarriersaddressController from "./carriersaddress_controller"
import CheckboxController from "./checkbox_controller"
import DragController from "./drag_controller"
import FillFormController from "./fill_form_controller"
import InfiniteScrollController from "./infinite_scroll_controller"
import LoadsBulkController from "./loads_bulk_controller"
import LocationsaddressController from "./locationsaddress_controller"
import MentionsController from "./mentions_controller"
import NavbarController from "./navbar_controller"
import NestedFormController from "./nested_form_controller"
import NotificationsController from "./notifications_controller"
import PaypalController from "./paypal_controller"
import PricingController from "./pricing_controller"
import RegionmapController from "./regionmap_controller"
import SearchController from "./search_controller"
import SearchTopbarController from "./search_topbar_controller"
import StatusdropdownController from "./statusdropdown_controller"
import StopsearchController from "./stopsearch_controller"
import StoptypeformController from "./stoptypeform_controller"
import StripeController from "./stripe_controller"
import SwitchController from "./switch_controller"
import TooltipController from "./tooltip_controller"
import ToggleController from "./toggle_controller"
import JsonViewerController from "./json_viewer_controller"

application.register("autocomplete", AutocompleteController)
application.register("braintree", BraintreeController)
application.register("carrierautocomplete", CarrierautocompleteController)
application.register("carriersaddress", CarriersaddressController)
application.register("checkbox", CheckboxController)
application.register("drag", DragController)
application.register("fill-form", FillFormController)
application.register("infinite-scroll", InfiniteScrollController)
application.register("loads-bulk", LoadsBulkController)
application.register("locationsaddress", LocationsaddressController)
application.register("mentions", MentionsController)
application.register("navbar", NavbarController)
application.register("nested-form", NestedFormController)
application.register("notifications", NotificationsController)
application.register("paypal", PaypalController)
application.register("pricing", PricingController)
application.register("regionmap", RegionmapController)
application.register("search", SearchController)
application.register("search-topbar", SearchTopbarController)
application.register("statusdropdown", StatusdropdownController)
application.register("stopsearch", StopsearchController)
application.register("stoptypeform", StoptypeformController)
application.register("stripe", StripeController)
application.register("switch", SwitchController)
application.register("toggle", ToggleController)
application.register("tooltip", TooltipController)
application.register("json-viewer", JsonViewerController)

// Third-party Stimulus components
import { Alert, Dropdown, Modal, Tabs } from "tailwindcss-stimulus-components"
application.register("alert", Alert)
application.register("dropdown", Dropdown)
application.register("modal", Modal)
application.register("tabs", Tabs)

import Flatpickr from "stimulus-flatpickr"
application.register("flatpickr", Flatpickr)
